import { environmentDefaults } from './environment-defaults';
import * as defaultsDeep from 'lodash.defaultsdeep';

const override = {
  baseUrl: 'https://groups-service.onyxcentersource.com',
  hostname: 'groups.onyxcentersource.com',
  portalUrl: 'https://portal.onyxcentersource.com',
  onyxCommonDataUrl: 'https://ocd.service.onyxcentersource.com/api',

  emailValidation: true,

  logServices: {
    consoleLogSubscriber: {
      logLevel: 2
    },
    httpLogSubscriber: {
      logLevel: 0
    }
  }
};

export const environment = defaultsDeep(override, environmentDefaults);



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/environments/environment.prod.ts